import { render, staticRenderFns } from "./TaskRatingItem.vue?vue&type=template&id=2c9e5684&scoped=true&"
import script from "./TaskRatingItem.vue?vue&type=script&lang=js&"
export * from "./TaskRatingItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskRatingItem.vue?vue&type=style&index=0&id=2c9e5684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e5684",
  null
  
)

export default component.exports